"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _formSerialize = _interopRequireDefault(require("form-serialize"));

var _animation = _interopRequireDefault(require("@spothero/utils/animation"));

var _dom = _interopRequireDefault(require("@spothero/utils/dom"));

var Form =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Form, _Component);

  function Form(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Form);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Form).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_onSubmit", function (evt) {
      evt.preventDefault();
      var onSubmit = _this.props.onSubmit;
      var form = evt.currentTarget; // for browsers that don't run validation checks on submit

      if (form.checkValidity && !form.checkValidity()) {
        return;
      } else {
        if (onSubmit) {
          onSubmit(evt);
        }
      }
    });

    if (!props.id) {
      throw new Error("The prop 'id' is required to make Form accessible for users using assistive technologies such as screen readers. Check the render method of Form.");
    }

    return _this;
  }

  (0, _createClass2.default)(Form, [{
    key: "animateToInvalid",

    /**
     * Animates the Form component to the first invalid field.
     *
     * @public
     * @returns {void}
     */
    value: function animateToInvalid() {
      if (this._form.checkValidity && !this._form.checkValidity()) {
        var _this$props = this.props,
            id = _this$props.id,
            invalidElementToScroll = _this$props.invalidElementToScroll,
            invalidElementScrollOffset = _this$props.invalidElementScrollOffset; // setTimeout to ensure elements are rendered

        (0, _setTimeout2.default)(function () {
          var errorField = _dom.default.el("#Form-".concat(id, " .FormElement-contains-error"));

          var firstInvalid = errorField.length > 0 ? errorField[0] : errorField;
          var yPos = firstInvalid.offsetTop + invalidElementScrollOffset;
          var elToScroll = invalidElementToScroll || document.scrollingElement;

          _animation.default.scrollTo(elToScroll, yPos);
        }, 0);
      }
    }
    /**
     * Checks if the form is valid and ready for submission.
     *
     * @public
     * @returns {Boolean} - Whether the form is valid or not.
     */

  }, {
    key: "isValid",
    value: function isValid() {
      return this._form.checkValidity ? this._form.checkValidity() : true;
    }
    /**
     * Resets user input from the form fields.
     *
     * @public
     * @returns {void}
     */

  }, {
    key: "reset",
    value: function reset() {
      this._form.reset();
    }
    /**
     * Provides the form data as an object for submission.
     *
     * @public
     * @param {Boolean} [withEmpty=false] - Whether to serialize the empty fields.
     * @returns {Object} - The form data to submit.
     */

  }, {
    key: "submit",
    value: function submit() {
      var withEmpty = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!this.isValid()) {
        return null;
      }

      return (0, _formSerialize.default)(this._form, {
        hash: true,
        empty: withEmpty
      });
    }
    /**
     * Getter for the form DOM element.
     *
     * @public
     * @returns {Element} - The form element.
     */

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          className = _this$props2.className,
          id = _this$props2.id,
          children = _this$props2.children;
      var classes = (0, _classnames.default)('Form', className);
      return _react.default.createElement("form", {
        ref: function ref(node) {
          _this2._form = node;
        },
        className: classes,
        id: "Form-".concat(id),
        onSubmit: this._onSubmit,
        action: ""
      }, children);
    }
  }, {
    key: "node",
    get: function get() {
      return this._form;
    }
  }]);
  return Form;
}(_react.Component);

exports.default = Form;
(0, _defineProperty2.default)(Form, "defaultProps", {
  invalidElementScrollOffset: 0
});